// extracted by mini-css-extract-plugin
module.exports = {"gridFlex":"components_gridFlex__2yy56"};